import axios from "axios";
import {setSnackbar, setUser} from "../../../util/state/globalAction";
import {GlobalContext} from "../../../util/state/GlobalContextProvider";
import {useContext} from "react";
import {snackbarTypes} from "../../../util/state/globalVariables";
import {useTranslation} from "react-i18next";
import {OidcProvider} from "../page/AdfsLoginPage";
import {getCookie} from "../../../util/state/commonFunctions";


export const useUserActions = () => {
    const {dispatchGlobalData} = useContext(GlobalContext);
    const {t} = useTranslation(['operator']);

    return {
        login,
        logout,
        getUser
    }

    function getUser(username: string) {
        return axios({
            method: 'post',
            url: '/getUserData',
            data: {
                username
            },
        }).then(async response => {
            await getMenuItems(response.data);
        }).finally(() => {
            return true;
        });
    }

    function login(username: string, password: string) {
        return axios({
            method: 'post',
            url: '/authenticate',
            data: {
                username,
                password
            },
        }).then(response => {
            let user = response.data;
            if (user.mobilityStores && user.mobilityStores[0]?.name === 'all') {
                user.mobilityStores[0].name = t('label.all');
            }
            if (user.logisticCompounds && user.logisticCompounds[0]?.name === 'all') {
                user.logisticCompounds[0].name = t('label.all');
            }
            if (user.verifyCodeEnabled) {
                window.location.href = "/verify-code";
            } else {
                getMenuItems(user);
            }
        });
    }

    function logout() {
        let pathOrigin = window.location.origin;
        axios({
            method: 'get',
            url: '/exit'
        }).finally(async () => {
            localStorage.removeItem('user');
            dispatchGlobalData({
                type: setSnackbar,
                payload: {
                    snackbar: {
                        message: "Loading...",
                        type: snackbarTypes.loading,
                        show: false,
                        autoClose: true,
                    }
                }
            });

            // @ts-ignore
            if (pathOrigin === `${window?.appConfig?.ADFS_ORIGIN}` || pathOrigin === `${window?.appConfig?.ADFS_INTRA_ORIGIN}`) {

                // @ts-ignore
                let logoutUrl = `${window?.appConfig?.ADFS_BASE_URL}/logout`;
                // @ts-ignore
                if (OidcProvider.TRUSTBUILDER === window?.appConfig?.OIDC_PROVIDER){
                    logoutUrl += `?id_token_hint=${getCookie("id_token")}`
                }

                if (getCookie("id_token") != undefined){
                    document.cookie = "id_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
                    window.location.href = logoutUrl;
                } else {
                    window.location.href = "/login";
                }
                
            } else {
                window.location.href = "/login";
            }
        });
    }

    function sortMenu(menuItems: any[]) {
        menuItems.sort((a: any, b: any) => {
            return a.id - b.id;
        });
        menuItems.forEach((item: any) => {
            if (item.menuSubItems && item.menuSubItems.length > 0) {
                sortMenu(item.menuSubItems);
            }
        });
    }

    function getMenuItems(user: any) {
        return axios({
            method: 'get',
            url: '/menu',
        }).then(response => {
            user.menuItems = response.data;
            sortMenu(user.menuItems);
            localStorage.setItem('user', JSON.stringify(user));
            const paths = getMenuPaths(user.menuItems);
            localStorage.setItem('paths', JSON.stringify(paths));
            dispatchGlobalData({
                type: setUser,
                payload: {
                    user: user
                }
            });
            window.location.href = "/";
        });
    }

    interface MenuItem {
        id: number;
        code: string;
        path: string;
        title: string;
        deep: number;
        auth: {
            id: number;
            name: string;
            department: string;
            feature: string;
        };
        menuSubItems: MenuItem[];
    }

    function getMenuPaths(menuItems: MenuItem[], parentPath: string = ''): string[] {
        const paths: string[] = [];

        menuItems.forEach((menuItem) => {
            const currentPath = `${parentPath}${menuItem.path}`;
            paths.push(currentPath);

            if (menuItem.menuSubItems.length > 0) {
                const subPaths = getMenuPaths(menuItem.menuSubItems, currentPath);
                paths.push(...subPaths);
            }
        });

        return paths;
    }

}
